export type CanCheckin = 'available' | 'unavailable' | 'checkedin' | 'user_cant' | 'with_token' | 'full';

export interface ProgramClass {
  id: string;
  checkin?: {id: string} | null;
  startTime: string;
  endTime: string;
  limit?: number | null;
  countCheckins?: number | null;
  canCheckin?: CanCheckin | string | null;
  program?: {name?: string | null} | null;
  filial?: {name?: string | null} | null;
  coach?: {name?: string | null} | null;
}

export type StatusTom = 'positivo' | 'neutro' | 'bloqueado';

export interface StatusAula {
  label: string;
  tom: StatusTom;
}

// Espelha o CanCheckinEnum do backend. Um valor novo la nao pode virar tela
// quebrada aqui, entao o default e neutro e silencioso.
const STATUS: Record<string, StatusAula> = {
  checkedin: {label: 'Check-in feito', tom: 'positivo'},
  available: {label: 'Disponível', tom: 'positivo'},
  with_token: {label: 'Disponível', tom: 'positivo'},
  full: {label: 'Lotada', tom: 'bloqueado'},
  user_cant: {label: 'Indisponível', tom: 'bloqueado'},
  unavailable: {label: 'Fechado', tom: 'neutro'},
};

export const statusDaAula = (valor?: string | null): StatusAula =>
  STATUS[valor ?? ''] ?? {label: '', tom: 'neutro'};

// O backend exige tz e recusa a query sem ele. Fuso do dispositivo, com
// America/Sao_Paulo como rede de seguranca para navegador sem Intl resolvido.
export const resolveTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Sao_Paulo';
  } catch {
    return 'America/Sao_Paulo';
  }
};

// startTime chega como "06:00" ou "06:00:00"; a lista fica ilegivel sem ordem
// e o backend nao garante nenhuma.
export const horaCurta = (valor?: string | null): string => (valor ?? '').slice(0, 5);

export const ordenarPorHorario = (aulas: ProgramClass[]): ProgramClass[] =>
  [...aulas].sort((a, b) => {
    const porHora = horaCurta(a.startTime).localeCompare(horaCurta(b.startTime));
    if (porHora !== 0) return porHora;

    // Mesmo horario em filiais diferentes: agrupa por filial para nao
    // intercalar unidades na lista.
    return (a.filial?.name ?? '').localeCompare(b.filial?.name ?? '', 'pt-BR');
  });

export const lotacao = (aula: ProgramClass): string => {
  const feitos = aula.countCheckins ?? 0;

  // Sem limite definido, mostrar "3/0" seria pior que mostrar so o total.
  if (!aula.limit) return `${feitos}`;

  return `${feitos}/${aula.limit}`;
};

export const estaLotada = (aula: ProgramClass): boolean =>
  Boolean(aula.limit) && (aula.countCheckins ?? 0) >= (aula.limit as number);

// So essas duas situacoes permitem agir: 'available' abre o check-in e
// 'checkedin' abre o cancelamento. As demais (full, user_cant, unavailable)
// sao informativas — mostrar um botao que sempre falha seria pior.
export const podeFazerCheckin = (aula: ProgramClass): boolean => aula.canCheckin === 'available';

export const podeCancelarCheckin = (aula: ProgramClass): boolean =>
  aula.canCheckin === 'checkedin' && Boolean(aula.checkin?.id);
